import React from 'react';
import Locations from './Locations';

export const LocationList = () => {
  return <Locations />;
};

export default LocationList;
